import React, { useEffect, useState } from "react";
import { fetchAuditLogs } from "../services/auditLogService";

export default function AuditLogPage() {
  const [rows, setRows] = useState([]);
  const [action, setAction] = useState("");
  const [col, setCol] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const data = await fetchAuditLogs({ action: action || undefined, collection: col || undefined });
      setRows(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="space-y-4">
      <header>
        <h1 className="text-2xl font-bold">Audit Log</h1>
        <p className="text-sm text-slate-600">Admin actions from <code>admin_logs</code>.</p>
      </header>
      <div className="fa-card flex flex-wrap gap-2 p-4">
        <input className="rounded-lg border px-2 py-1.5 text-sm" placeholder="Action filter" value={action} onChange={(e) => setAction(e.target.value)} />
        <input className="rounded-lg border px-2 py-1.5 text-sm" placeholder="Collection filter" value={col} onChange={(e) => setCol(e.target.value)} />
        <button type="button" className="fa-btn fa-btn-primary" onClick={load} disabled={loading}>Refresh</button>
      </div>
      <div className="fa-card fa-table-wrap">
        <table className="fa-table">
          <thead>
            <tr>
              <th>Time</th>
              <th>Admin</th>
              <th>Action</th>
              <th>Collection</th>
              <th>Docs</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td className="text-xs">{r.dateTime}</td>
                <td>{r.adminName}</td>
                <td>{r.action}</td>
                <td>{r.collection}</td>
                <td>{(r.documentIds || []).length}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
